import React from 'react';
import iviLogo from '../assets/ivi-sign-logo.svg';
import premierLogo from '../assets/premier-logo.svg';
import appsmartLogo from '../assets/appsmartlogo.svg';
import magnitLogo from '../assets/magnitlogo.svg';
import beelinepopcornLogo from '../assets/beelinepopcorn.svg';
import { PrimaryButton } from '../ui/Button';
import { trackClick } from '../utils/yandexMetrika';

const PartnersSection: React.FC = () => {
    const logos = [
        { src: iviLogo, alt: 'ivi' },
        { src: premierLogo, alt: 'Premier' },
        { src: appsmartLogo, alt: 'Appsmart' },
        { src: beelinepopcornLogo, alt: 'Beeline' },
        { src: magnitLogo, alt: 'Magnit' }
    ];

    return (
        <section id="partners" className="section partners-section reveal">
            <div className="container text-center">
                <h2 className="section-title">С кем я <strong>сотрудничала</strong></h2>
                <p className="subtitle-context centered">
                    Работала с продуктами, которыми пользуются <strong>10+ миллионов человек</strong>.
                    Скорее всего, они уже есть в вашем смартфоне.
                </p>

                <p className="subtitle-context centered" style={{ marginBottom: '0' }}>
                    Здесь можно узнать больше про мой опыт
                </p>

                <div className="marquee-outer-wrapper glass-card-mini" style={{ marginTop: '30px', marginBottom: '30px' }}>
                    <div className="marquee-container">
                        <div className="marquee-content">
                            {/* Рендерим 3 набора для бесшовной анимации */}
                            {[...Array(3)].map((_, i) => (
                                <React.Fragment key={i}>
                                    {logos.map((logo, idx) => (
                                        <div className="logo-capsule" key={`${i}-${idx}`}>
                                            <img src={logo.src} alt={`Логотип ${logo.alt}`} className="company-logo"/>
                                        </div>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="portfolio-button-wrapper" style={{ marginTop: '30px', textAlign: 'center' }}>
                    <PrimaryButton
                        href="#portfolio"
                        onClick={() => {
                            trackClick('partners_portfolio');
                            window.dispatchEvent(new CustomEvent('openPortfolio'));
                        }}
                    >
                        Портфолио
                    </PrimaryButton>
                </div>
            </div>
        </section>
    );
};

export default PartnersSection;